import { DAYS_LONG } from '../lib/format';
import { GROUPS } from '../lib/places';
import type { PlaceGroup } from '../lib/types';

export const TAGS = ['Food', 'Pizza', 'Fish fry', 'Pool', 'Live music', 'Breakfast', 'Patio', 'Dive', 'Dog friendly', 'Cash only', 'Biker friendly', 'Karaoke'];

export function TagToggles({ value, onChange }: { value: string[]; onChange: (tags: string[]) => void }) {
  return (
    <div className="flex flex-wrap gap-1.5" role="group" aria-label="Looking for">
      {TAGS.map((t) => {
        const on = value.includes(t);
        return (
          <button
            key={t}
            type="button"
            aria-pressed={on}
            className={`btn btn-sm ${on ? 'border-amber bg-panel-2 text-amber-hi' : ''}`}
            onClick={() => onChange(on ? value.filter((x) => x !== t) : [...value, t])}
          >
            {t}
          </button>
        );
      })}
    </div>
  );
}

export function ScoreSlider({ value, onChange, id = 'minScore' }: { value: number; onChange: (n: number) => void; id?: string }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id}>
        Backroad score at least <span className="tabular-nums text-amber">{value}</span>
      </label>
      <input id={id} type="range" min={0} max={90} step={5} value={value} onChange={(e) => onChange(Number(e.target.value))} />
      <span className="text-[13px] text-dim">Higher = more rural, more character, fewer chains and city spots.</span>
    </div>
  );
}

export function DaySelect({ value, onChange, id = 'day' }: { value: number | ''; onChange: (d: number | '') => void; id?: string }) {
  return (
    <div className="flex flex-col gap-1.5">
      <label htmlFor={id}>Open on</label>
      <select id={id} value={value} onChange={(e) => onChange(e.target.value === '' ? '' : Number(e.target.value))}>
        <option value="">Any day</option>
        {DAYS_LONG.map((d, i) => (
          <option key={d} value={i}>
            {d}
          </option>
        ))}
      </select>
    </div>
  );
}

/** Bars / Bites / Both, as a row of chips. */
export function GroupChips({
  value,
  onChange,
  className = '',
  label = 'Show',
}: {
  value: PlaceGroup;
  onChange: (g: PlaceGroup) => void;
  className?: string;
  label?: string;
}) {
  return (
    <div className={`inline-flex rounded-full border border-line-2 bg-asphalt p-1 ${className}`} role="radiogroup" aria-label={label}>
      {GROUPS.map((g) => {
        const on = g.value === value;
        return (
          <button
            key={g.value}
            type="button"
            role="radio"
            aria-checked={on}
            onClick={() => onChange(g.value)}
            className={`min-h-9 rounded-full px-4 text-sm font-semibold ${on ? 'bg-amber text-amber-ink' : 'text-cream hover:bg-panel'}`}
          >
            {g.label}
          </button>
        );
      })}
    </div>
  );
}
